import { InputSwitch } from "primereact/inputswitch";
import { AppTooltip } from "../../../../common/components/tooltip/AppTooltip";
import styles from "./AutoPayToggle.module.scss";

interface IAutoPayToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  disabled: boolean;
  cardBrand?: string | null;
  cardLast4?: string | null;
}

/**
 * Постоянният превключвател на автоматичното плащане. Стои в хедъра на списъка
 * с фактури (до заглавието), за да е достъпен винаги — включително когато всички
 * фактури вече се плащат автоматично и няма бутон "Плати", от който да се отвори
 * диалогът.
 */
export const AutoPayToggle = ({
  enabled,
  onChange,
  disabled,
  cardBrand,
  cardLast4,
}: IAutoPayToggleProps) => (
  <div className={styles.root}>
    <label htmlFor="autoPayPageSwitch" className={styles.root_label}>
      <span className={styles.root_label_title}>Автоматично плащане</span>
      {cardLast4 && (
        <span className={styles.root_label_card}>
          {cardBrand ?? "карта"} •••• {cardLast4}
        </span>
      )}
    </label>
    <AppTooltip
      className={styles.root_tooltip}
      content="Когато е включено, всяка нова фактура се плаща автоматично със запазената карта. Можете да го изключите по всяко време."
    />
    <InputSwitch
      inputId="autoPayPageSwitch"
      checked={enabled}
      onChange={(e) => onChange(!!e.value)}
      disabled={disabled}
    />
  </div>
);
